import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, withApollo } from 'react-apollo';
import { compose, mapProps } from 'recompose';
import PropTypes from 'prop-types';

import CheckboxGroup from 'components/common/CheckboxGroup/CheckboxGroup';
import { updateValuesListFieldValue, ddeActionsTriggered } from 'graphql/operations';
import { createSelectionValidationFn } from 'utils/validations/validations';
import decodeHtml from 'utils/htmlDecoder';
import SaveAnswerHOC from '../SaveAnswerHOC';
import EventHandlerHOC from '../FieldUpdatesHOC';

export const CheckboxAnswer = props => {
  const { question, disabled, save, filterValues } = props;
  const { minimumSelection, maximumSelection, calculated } = question;
  const { t } = useTranslation();
  let options = [];
  if (filterValues && filterValues.length > 0) {
    options = filterValues.map(valuesListField => ({ value: valuesListField, label: decodeHtml(valuesListField) }));
  } else {
    options = question.possibleValues.map(valuesListField => ({ value: valuesListField.value, label: decodeHtml(valuesListField.value) }));
  }

  const handleValidationError = useCallback(
    selectedValues => {
      save(selectedValues);
    },
    [save]
  );

  const handleChange = useCallback(
    selectedValues => {
      save(selectedValues);
    },
    [save]
  );

  const inputValidation = createSelectionValidationFn(minimumSelection, maximumSelection);

  const errorObj = question.listValue && question.listValue.length > 0 ? inputValidation(question.listValue.length) : null;

  return (
    <CheckboxGroup
      t={t}
      options={options}
      disabled={calculated || disabled}
      checked={question.listValue}
      onChange={handleChange}
      inputValidation={inputValidation}
      onValidationError={handleValidationError}
      error={errorObj ? t(errorObj.key, { ...errorObj.args }) : null}
    />
  );
};

CheckboxAnswer.defaultProps = {
  disabled: false
};

CheckboxAnswer.propTypes = {
  disabled: PropTypes.bool,
  // TODO: Fix this...
  /* eslint-disable react/forbid-prop-types */
  save: PropTypes.any.isRequired,
  question: PropTypes.object.isRequired
  /* eslint-enable react/forbid-prop-types */
};

export const CheckboxAnswerHOC = compose(
  withApollo,
  graphql(updateValuesListFieldValue, { name: 'fieldMutation' }),
  graphql(ddeActionsTriggered, { name: 'ddeActionsTriggered' }),
  EventHandlerHOC,
  SaveAnswerHOC,
  mapProps(props => ({
    question: props.question,
    save: props.save,
    disabled: props.disabled,
    filterValues: props.filterValues,
    invokeActionsForFields: props.invokeActionsForFields,
    SVLAction: props.SVLAction
  }))
);

export default CheckboxAnswerHOC(CheckboxAnswer);
